import { FC } from 'react'

import { RadioProps } from 'antd'
import styled from 'styled-components'

import { PaymentMethodEnum } from 'src/Constants/enums'
import { PrimaryRadio } from 'src/Components/PrimaryRadio'

type Props = RadioProps

const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
export const CreditsRadioButton: FC<Props> = (props) => (
  <PrimaryRadio value={PaymentMethodEnum.Credits} {...props}>
    <Text>Credits from balance</Text>
  </PrimaryRadio>
)
